import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import EventEmitter from './EventEmitter.js'

/**
 * Resources
 * Loads all assets defined in sources.js using the appropriate Three.js loader.
 * Stores loaded assets by name in this.items.
 * Triggers 'ready' once every source has finished loading.
 */
export default class Resources extends EventEmitter {
    constructor(sources) {
        super()

        this.sources = sources
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0

        this.setLoaders()
        this.startLoading()
    }

    setLoaders() {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
    }

    startLoading() {
        if (this.toLoad === 0) {
            // No sources — fire ready on next tick so listeners can register first
            window.setTimeout(() => this.trigger('ready'), 0)
            return
        }

        for (const source of this.sources) {
            if (source.type === 'gltfModel') {
                this.loaders.gltfLoader.load(source.path, (file) => this.sourceLoaded(source, file))
            } else if (source.type === 'texture') {
                this.loaders.textureLoader.load(source.path, (file) => this.sourceLoaded(source, file))
            } else if (source.type === 'cubeTexture') {
                this.loaders.cubeTextureLoader.load(source.path, (file) => this.sourceLoaded(source, file))
            }
        }
    }

    sourceLoaded(source, file) {
        this.items[source.name] = file
        this.loaded++

        if (this.loaded === this.toLoad) {
            this.trigger('ready')
        }
    }
}
